<div
  class="loader-wrapper"
  [class.p-16]="!isAbsolute"
>
  <div
    class="loader loader--{{ size }}" [class.loader--no-bg]="!showBackground"
    [class.position-absolute]="isAbsolute"
    [class.full-width]="isAbsolute"
    [class.full-height]="isAbsolute"
  >
    <span></span>
  </div>
  <ng-content />
</div>
